import React, {memo, useEffect} from 'react';
import styles from './styles.module.scss';
import useEmailsInWhiteList from "@/app/features/emailsInWhiteList/slice";
import {TextMedium14} from "@/app/components/texts";

const EmailsInWhiteList = () => {
  const {state, init} = useEmailsInWhiteList();

  useEffect(() => {
    init();
  }, []);

  return (
    <div className={styles.emailsInWhiteList}>
      {state.emails.map((item, index) => <div>
        <TextMedium14 text={item.email} key={index}/>
      </div>)}
    </div>
  );
};

export default memo(EmailsInWhiteList);
